import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import { Flex, message, Space, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { useAddToCart } from '@hub/api/mutations';
import { PagePath, VerificationButtonTypes } from '@monorepo/client-types';
import {
  AddItemToCartDto,
  AddOn,
  AddOnType,
  CartStep,
  OptionalAssets,
  ProductType,
  SupportedCurrencies,
  ThemeColors,
} from '@monorepo/types';
import VerificationRequiredButton from '../../components/verification-required-button/verification-required-button';
import { useStore } from '../../helpers/use-store';

const AddOns: FunctionComponent<{
  accountId: string;
  type?: AddOnType;
  themeColor?: ThemeColors;
  icon?: React.ReactNode;
  displayName?: string;
}> = ({ accountId, type, themeColor, icon, displayName }) => {
  const {
    dataStore: { addOnStore },
  } = useStore();
  const { mutateAsync: addToCart } = useAddToCart();
  const navigate = useNavigate();

  const onAddOnClick = async (addOnId: string) => {
    if (!addOnId) return;
    try {
      const newItem: AddItemToCartDto = {
        item: {
          productId: addOnId,
          productType: ProductType.AddOn,
          metadata: { sourceId: accountId },
        },
        currency: SupportedCurrencies.USD,
        chosenAsset: OptionalAssets.QuickBuy,
      };

      await addToCart(newItem);
      navigate(
        `${PagePath.Purchase}?step=${CartStep.Billing}&asset=${OptionalAssets.QuickBuy}`,
      );
    } catch {
      message.error('Could not use add-on');
    }
  };

  const addOnsByType = addOnStore.getAddOns(type);

  const addOnButtonText = (addon: AddOn) =>
    displayName ? displayName : addon.name;
  return (
    <Flex
      style={{
        justifyContent: 'flex-end',
        paddingTop: '10px',
        paddingBottom: '10px',
      }}
    >
      <Space direction="horizontal" size="middle">
        {addOnsByType.map((item) => (
          <VerificationRequiredButton
            placement={VerificationButtonTypes.ADDONS}
            key={item._id}
            onClick={() => onAddOnClick(item._id)}
            type={'primary'}
            themeColor={themeColor}
            icon={icon}
          >
            <Tooltip title={item.description}>{addOnButtonText(item)}</Tooltip>
          </VerificationRequiredButton>
        ))}
      </Space>
    </Flex>
  );
};

export default observer(AddOns);
